import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import futbolistaService from '../services/futbolistaService';
import '../styles/help.css';

const Help = () => {
  const { user } = useAuth();
  const [futbolistas, setFutbolistas] = useState([]);

  // Cargar futbolistas al montar el componente
  useEffect(() => {
    const loadFutbolistas = async () => {
      try {
        const data = await futbolistaService.getFutbolistas();
        setFutbolistas(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error al cargar futbolistas:', error);
        setFutbolistas([]);
      }
    };

    if (user) {
      loadFutbolistas();
    }
  }, [user]);

  // Verificar si el usuario tiene futbolistas
  const hasFutbolistas = futbolistas.length > 0;

  // Grupos de WhatsApp por sede
  const getGruposWhatsApp = () => {
    return [
      {
        categoria: 'SEDE ALICANTE',
        enlace: 'https://chat.whatsapp.com/DqQrLox6plF0LRAzsXm8t2'
      },
      {
        categoria: 'SEDE ALGORFA',
        enlace: 'https://chat.whatsapp.com/Hbtc4naNG5dDny8qn116dW'
      }
    ];
  };

  return (
    <div className="help-page">
      <div className="container">
        <div className="help-header">
          <h1>¡Bienvenido a la app de La Liga ProKids! 🎉</h1>
          <p>Te ayudamos a seguir paso a paso el proceso de inscripción</p>
        </div>

        <div className="help-content">
          <div className="steps-container">
            <h2>Próximos pasos para reservar tu plaza:</h2>
            
            <div className="steps-list">
              <div className={`step-item ${hasFutbolistas ? 'step-completed' : ''}`}>
                <div className="step-number">
                  1
                  {hasFutbolistas && (
                    <span className="step-status-icon completed">
                      <span className="material-icons">check_circle</span>
                    </span>
                  )}
                </div>
                <div className="step-content">
                  <h3>
                    Crea el perfil de tus Futbolistas
                    {hasFutbolistas && <span className="status-text completed">✅ Completado</span>}
                  </h3>
                  <p><strong>¡PASO FUNDAMENTAL!</strong> Sin el registro de un futbolista no se desbloqueará el proceso de Inscripción en las Jornadas.</p>
                  {hasFutbolistas ? (
                    <Link to="/tutor" className="btn btn-success btn-sm">
                      Ver Mis Futbolistas
                    </Link>
                  ) : (
                    <Link to="/tutor/futbolistas/nuevo" className="btn btn-primary btn-sm">
                      Crear Mi Primer Futbolista
                    </Link>
                  )}
                </div>
              </div>

              <div className={`step-item ${!hasFutbolistas ? 'step-disabled' : ''}`}>
                <div className="step-number">
                  2
                  {hasFutbolistas ? (
                    <span className="step-status-icon available">
                      <span className="material-icons">play_circle</span>
                    </span>
                  ) : (
                    <span className="step-status-icon disabled">
                      <span className="material-icons">lock</span>
                    </span>
                  )}
                </div>
                <div className="step-content">
                  <h3>
                    Reserva tu plaza en una jornada
                    {!hasFutbolistas && <span className="status-text disabled">🔒 Bloqueado</span>}
                    {hasFutbolistas && <span className="status-text available">🎯 Disponible</span>}
                  </h3>
                  <p>Una vez creado el perfil del futbolista, podrás inscribirlo en las jornadas disponibles de La Liga ProKids.</p>

                  <div className="equipment-reminder">
                    <div className="alert alert-warning">
                      <strong>👕 ¡Importante para nuevos jugadores!</strong>
                      <p>Si es tu primera vez, recuerda que debes comprar también la equipación, que se entrega el día de tu primer partido.</p>
                    </div>
                  </div>

                  {hasFutbolistas ? (
                    <Link to="/products" className="btn btn-primary btn-sm">
                      Comprar Paquetes de Jornadas
                    </Link>
                  ) : (
                    <button className="btn btn-secondary btn-sm" disabled>
                      Comprar Paquetes de Jornadas
                    </button>
                  )}
                </div>
              </div>

              <div className={`step-item ${!hasFutbolistas ? 'step-disabled' : ''}`}>
                <div className="step-number">
                  3
                  {hasFutbolistas ? (
                    <span className="step-status-icon available">
                      <span className="material-icons">groups</span>
                    </span>
                  ) : (
                    <span className="step-status-icon disabled">
                      <span className="material-icons">lock</span>
                    </span>
                  )}
                </div>
                <div className="step-content">
                  <h3>
                    Únete al grupo de WhatsApp
                    {!hasFutbolistas && <span className="status-text disabled">🔒 Bloqueado</span>}
                    {hasFutbolistas && <span className="status-text available">📱 Disponible</span>}
                  </h3>
                  <p>Únete al grupo oficial de WhatsApp de La Liga ProKids y entérate el primero de todo.</p>

                  {hasFutbolistas ? (
                    <div className="whatsapp-groups">
                      {getGruposWhatsApp().map((grupo, index) => (
                        <div key={index} className="whatsapp-group-item">
                          <strong>GRUPO {grupo.categoria}:</strong>
                          <a
                            href={grupo.enlace}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success btn-sm whatsapp-btn"
                          >
                            <span className="material-icons">chat</span>
                            Unirse al Grupo
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <button className="btn btn-secondary btn-sm" disabled>
                      Crear futbolista primero
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="help-sections">
            <div className="help-section">
              <h3>💳 Formas de pago</h3>
              <div className="payment-methods">
                <div className="payment-method">
                  <h4>💳 Pago directo desde la app</h4>
                  <ul>
                    <li><strong>Bizum:</strong> Pago instantáneo y seguro</li>
                    <li><strong>Tarjeta:</strong> Visa, Mastercard, American Express</li>
                  </ul>
                </div>

                <div className="payment-method">
                  <h4>🏦 Transferencia bancaria</h4>
                  <div className="bank-details">
                    <p><strong>Enviar justificante al:</strong> 📱 <a href="tel:604972879">604 972 879</a></p>
                    <div className="bank-info">
                      <p><strong>🏦 Nº de cuenta:</strong> <code>ES50 0182 0111 4602 0162 6446</code></p>
                      <p><strong>✍ Concepto:</strong> Nombre del niño/a</p>
                      <p><strong>👤 Beneficiario:</strong> Liga Prokids</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="help-section">
              <h3>ℹ️ Información importante</h3>
              <ul>
                <li>Las jornadas se cierran siempre 3 días antes del día del partido a las 23:59 y el horario se recibe 2 días antes. Para asegurar la plaza hay que realizar la inscripción (comprar la jornada) antes del cierre:
                  <ul>
                    <li>Si el partido es domingo la inscripción se puede realizar hasta el jueves a las 23:59 y el horario del partido se recibe el viernes.</li>
                    <li>Si el partido es sábado la inscripción se puede realizar hasta el miércoles a las 23:59 y el horario del partido se recibe el jueves.</li>
                  </ul>
                </li>
                <li>Si has comprado una jornada y no puedes venir, en tu perfil está la opción &quot;NO VOY&quot;: Mis Futbolistas - Ver Torneos y jornadas - No voy (la jornada se pospone automáticamente a la siguiente. Hay que hacerlo antes del cierre de inscripciones).</li>
                <li>Cuando compras una jornada/pack puedes elegir con el calendario. Si no seleccionas una concreta se comprará la próxima automáticamente.</li>
                <li>Los packs funcionan igual, si no seleccionas las jornadas en el calendario, al comprar 4 u 8 jornadas, se reservan las próximas.</li>
              </ul>
            </div>

            <div className="help-section">
              <h3>💡 Consejos útiles</h3>
              <ul>
                <li><strong>Empieza por crear tu futbolista:</strong> Es el primer paso obligatorio para usar la app. Una vez lo hayas hecho puedes comprar jornadas. Un usuario puede registrar a varios futbolistas (hermanos, amigos…). Al comprar jornadas, se elige para qué futbolista son. También puedes elegir la sede.</li>
                <li>Los datos del futbolista se usan para organizar los partidos por edad y nivel.</li>
                <li>El futbolista es quien acumula los puntos tras cada jornada, desbloquea logros, sube de nivel y consigue premios. Consulta toda la información de nuestro <Link to="/propoints">Sistema ProPoints</Link>.</li>
              </ul>
            </div>
          </div>

          <div className="help-footer">
            <div className="alert alert-info">
              <h4>¿Necesitas más ayuda?</h4>
              <p>Si tienes alguna duda o problema, no dudes en contactarnos:</p>
              <ul>
                <li><strong>📱 WhatsApp:</strong> <a href="tel:604972879">604 972 879</a></li>
                <li><strong>Email:</strong> contactoligaprokids@gmail.com</li>
                <li><strong>Horario:</strong> Lunes a Viernes de 9:00 a 18:00</li>
              </ul>
              <Link to="/contact" className="btn btn-secondary">
                Página de Contacto
              </Link>
            </div>

            <div className="final-message">
              <h3>⚽ ¡Nos vemos en el campo!</h3>
              <p>¡Gracias por unirte a La Liga ProKids! Esperamos verte pronto en nuestras jornadas.</p>
            </div>
          </div>

          <div className="navigation-buttons">
            <Link to="/tutor" className="btn btn-primary">
              Ir al Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
